import React from 'react';
import { Image, Platform, StyleSheet, Text, View } from 'react-native';
import { Marker } from 'react-native-maps';
import { Marker as WebMarker } from 'react-google-maps';

const UserMarker = ({ latitude, longitude, image, ...rest }) => {
  if (Platform.OS === 'web') {
    return (
      <WebMarker
        tracksViewChanges={false}
        position={{
          lat: latitude,
          lng: longitude,
        }}
      />
    );
  } else {
    if (Platform.OS === 'ios') {
      return (
        <Marker
          coordinate={{
            latitude: latitude,
            longitude: longitude,
          }}
          centerOffset={{ x: 0, y: -25 }}
          tracksViewChanges={false}
          {...rest}
        >
          <Image style={styles.image} source={image} />
        </Marker>
      );
    } else {
      return (
        <Marker
          coordinate={{
            latitude: latitude,
            longitude: longitude,
          }}
          tracksViewChanges={false}
          {...rest}
        >
          <View>
            <Image style={styles.image} source={image} />
          </View>
        </Marker>
      );
    }
  }
};

export default UserMarker;

const styles = StyleSheet.create({
  image: {
    width: 36,
    height: 36,
    borderRadius: 18,
  },
});
